export default function(params){
    let origin=params.styleData.Origin||1
    let offsetX=params.styleData.offsetX||10
    let offsetY=params.styleData.offsetY||150
    let width=params.configData.width||200
    let height=params.configData.height||290
    let position
    switch (origin) {
        case 1:
            position={
                top:`${offsetY}px`,
                left:`${offsetX}px`
            }
            break;
        case 2:
            position={
                top:`${offsetY}px`,
                right:`${offsetX}px`
            }
            break;
        case 3:
            position={
                bottom:`${offsetY}px`,
                left:`${offsetX}px`
            }
            break;
        case 4:
            position={
                bottom:`${offsetY}px`,
                right:`${offsetX}px`
            }
            break;
    }
    return {
        position:"fixed",
        ...position,
        zIndex:999,
        width:`${width}px`,
        height:`${height}px`
    }
}